import { useState } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import * as HoverCard from '@radix-ui/react-hover-card'
import { AnimatePresence } from 'framer-motion'

interface IHoverInfoCardProps {
  title?: string | null
  subtitle?: string | null
  description?: string | null
  children: React.ReactNode
  content?: React.ReactNode
}
const HoverInfoCard = ({
  title,
  subtitle,
  description,
  children,
  content,
}: IHoverInfoCardProps) => {
  const [open, setOpen] = useState(false)

  return (
    <HoverCard.Root open={open} onOpenChange={setOpen}>
      <HoverCard.Trigger asChild>{children}</HoverCard.Trigger>
      <HoverCard.Portal forceMount>
        <AnimatePresence>
          {open && (
            <HoverCard.Content
              forceMount
              side="top"
              sideOffset={10}
              collisionPadding={10}
              style={{ zIndex: 1000 }}
            >
              <Box.Motion
                boxShadow="s100"
                border={{ all: { color: 'grey400', width: 's1', style: 'solid' } }}
                borderRadius={{ all: 'abs012' }}
                padding="s12"
                background="overlayBackground"
                initial={{ pointerEvents: 'none', opacity: 0, y: 10 }}
                animate={{ pointerEvents: 'auto', opacity: 1, y: 0 }}
                exit={{ opacity: 0, pointerEvents: 'none' }}
                transition={{
                  duration: 0.3,
                }}
                minWidth="s360"
                width="s240"
                gap="s2"
                onClick={(e) => e.stopPropagation()}
                cursor="default"
              >
                {title && (
                  <Text.Normal size="300" weight="medium" color="grey1000">
                    {title}
                  </Text.Normal>
                )}
                {subtitle && <Text.Normal size="200">{subtitle}</Text.Normal>}
                {description && <Text.Normal size="200">{description}</Text.Normal>}
                {content && <Box paddingTop="s12">{content}</Box>}
              </Box.Motion>
            </HoverCard.Content>
          )}
        </AnimatePresence>
      </HoverCard.Portal>
    </HoverCard.Root>
  )
}

export default HoverInfoCard
